const mediaQuery = globalThis.matchMedia('(max-width: 800px)');
const isMobileBreakpoint = mediaQuery.matches;

// validates if the URL is a local URL
function isLocalUrl(href) {
  const clientPath = SITEBASEURL;
  return href !== null && href.includes(clientPath);
}

function targetBlank(href) {
  return isLocalUrl(href) ? '' : 'target="_blank"';
}

export { isMobileBreakpoint, isLocalUrl, targetBlank };
